import { fromJS, List } from 'immutable';

import * as AgreementCategories from '../actions/agreementCategories';

const defaultState = fromJS({
  sort: {},
  loading: false,
  data: List(),
});

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case AgreementCategories.LOADING_AGREEMENT_CATEGORIES_LIST: {
      return state.merge({
        loading: true,
      });
    }

    case AgreementCategories.LOADED_AGREEMENT_CATEGORIES_LIST: {
      return state.merge({
        loading: false,
        data: action.response.data,
      });
    }

    case AgreementCategories.LOADING_MANAGEMENT_AGREEMENT_CATEGORIES_LIST: {
      return state.merge({
        loading: true,
      });
    }

    case AgreementCategories.LOADED_MANAGEMENT_AGREEMENT_CATEGORIES_LIST: {
      const response = action.response.data;
      const children = response.flatMap(value => value.children);
      const childrenWithParentDetails = children.map(child => ({
        ...child,
        parent: action.response.data.find(value => value.id === child.parentId),
      }));

      const data = [];
      let parentId = '';

      childrenWithParentDetails.forEach(child => {
        if (child.parentId !== parentId) {
          const parent = response.find(value => value.id === child.parentId);

          data.push(parent);
          parentId = parent.id;
        }

        if (child.parentId) {
          data.push(child);
        }
      });

      // Add parents without children.
      response.forEach(child => {
        if (child.children.length === 0) {
          data.push(child);
        }
      });

      return state.merge({
        loading: false,
        data,
        parents: response,
      });
    }

    case AgreementCategories.AGREEMENT_CATEGORIES_SORT: {
      const nextState = state.set(
        'sort',
        fromJS({
          [action.field]: (state.getIn(['sort', action.field]) || -1) * -1,
        }),
      );

      return nextState.set('data', mapper[action.field](nextState, action));
    }

    default:
      return state;
  }
};

export default reducer;

const mapper = {
  category(state, action) {
    const direction = state.getIn(['sort', action.field]);

    return state.get('data').sort((a, b) => {
      const v1 = a.get('category', '');
      const v2 = b.get('category', '');

      return v1.localeCompare(v2) * direction;
    });
  },
  parent(state, action) {
    const direction = state.getIn(['sort', action.field]);

    return state.get('data').sort((a, b) => {
      const v1 = a.getIn(['parent', 'category'], '');
      const v2 = b.getIn(['parent', 'category'], '');

      return v1.localeCompare(v2) * direction;
    });
  },
};
